export default __webpack_public_path__ + "static/media/mr_mrs_smith_s3.f27ec3f6.png";